<template>
  <v-card class="business-process-summary-card background-surface-base">
    <EcsPassiveBusinessProcessSummaryCard
      v-if="!active"
      :business-process="businessProcess"
      :toggle-cards="toggleCards"
      :on-action-click="onPassiveCardClick"
    />
    <EcsActiveBusinessProcessSummaryCard
      v-show="active"
      ref="activeBusinessCard"
      :business-process="businessProcess"
      :default-from-email="defaultFromEmail"
      :default-bcc-email="defaultBccEmail"
      :toggle-cards="toggleCards"
    />
  </v-card>
</template>

<script>
import EcsPassiveBusinessProcessSummaryCard from '@/components/ecs-summary-view/EcsPassiveBusinessProcessSummaryCard';
import EcsActiveBusinessProcessSummaryCard from '@/components/ecs-summary-view/EcsActiveBusinessProcessSummaryCard';

export default {
  name: 'EcsBusinessProcessSummaryCard',

  components: { EcsPassiveBusinessProcessSummaryCard, EcsActiveBusinessProcessSummaryCard },

  data() {
    return {
      active: false
    };
  },

  props: {
    businessProcess: {
      type: Object,
      required: true
    },
    defaultFromEmail: {
      type: String,
      required: true
    },
    defaultBccEmail: {
      type: String,
      required: true
    }
  },

  methods: {
    toggleCards() {
      this.active = !this.active;
    },

    onPassiveCardClick(tabName) {
      this.$refs.activeBusinessCard.setActiveTab(tabName);
    }
  }
};
</script>

<style scoped>
.business-process-summary-card {
  height: 220px;
  min-width: 300px;
}
</style>
